import React from 'react'
import { cn } from '../../../utils/classnames'

const ClientStatusBadge = ({ status, tStatus }) => {
  const statusClass = status === 'active'
    ? 'bg-tealMedium'
    : 'bg-blueSteel'

  return (
    <span className={cn(
      'flex text-white w-custom70 py-1 rounded-full items-center justify-center text-xs uppercase font-semibold',
      statusClass
    )}>
      {tStatus?.toUpperCase() || 'N/A'}
    </span>
  )
}

export default ClientStatusBadge
